// {{{ API

const APP_NAME = "BCCP";
const APP_BASE = "/";
const API_BASE = APP_BASE + "api/";
REST.getURL = function(path) {
	return path.startsWith("/") ? path : API_BASE + path;
};

REST.getExtraHeaders = function(method, path, opts) {
	let headers = {};

	let group = Application.getActiveUserGroup();
	if (opts.activeUserGroup !== undefined) {
		if (opts.activeUserGroup != null) {
			headers['X-Active-User-Group'] = opts.activeUserGroup;
		}
	} else if (group) {
		headers['X-Active-User-Group'] = group.id;
	}

	return headers;
};

// }}}

// Application:

Application = new GW.Application({
        // {{{ Initialization

	initialLoad: true,
	
	'after:initComponent'() {
		this.initSocket();
		this.initResponsivity();
	},

	// }}}
	// {{{ WebSocket

	socketSubscriptionTopics: null,
	socket: null,

	initSocket() {
		let me = this;

		setTimeout(this.socketCheck.bind(this), Math.round(2000 + Math.random() * 1000));

		this.socketSubscriptionTopics = [];
		this.socket = Socket({
			log(...args) {
				console.debug(...args);
			},
	
			onOpen() {
			},

			onMessage(msg) {
				msg.__origin = 'websocket';
				me.dispatchMessage(msg);

				me.detectServerVersionChange(msg);

				/*
				 * We use this message as a isOpen change hint,
				 * to notify UI about websocket status.
				 */
				if (msg.type == 'READY') {
					Application.dispatchMessage({
						type: 'CLIENT_WEBSOCKET_STATUS_CHANGE',
						ready: true,
					});

					if (me.socketSubscriptionTopics.length > 0) {
						Application.updateSocketSubscriptions();
					}

					Application.updateSocketActiveModule(true);

					Performance.pushEvent({
						kind: 'socket-ready',
						cid: msg.cid,
					});
				}

				/**
				 * Reload session on session change (e.g. on extension change)
				 */
				if (msg.type == 'SESSION_CHANGED') {
					Application.reloadSession();
				}
			},

			onClose() {
				Application.dispatchMessage({
					type: 'CLIENT_WEBSOCKET_STATUS_CHANGE',
					ready: false,
				});

				Performance.pushEvent({
					kind: 'socket-closed',
				});
			},
		});
	},

	socketCheck() {
		// if the socket is not open and we're logged in,
		// re-open it
		if (!this.socket.isOpen() && this.session) {
			this.socket.open();
		}

		setTimeout(this.socketCheck.bind(this), Math.round(2000 + Math.random() * 1000));
	},

	socketSend(msg) {
		if (this.socket && this.socket.isReady() && this.socket.cid) {
			this.socket.send(msg);
		}
	},
	
	updateSocketSubscriptions() {
		this.socketSend({
			type: 'SUBSCRIBE',
			topics: this.socketSubscriptionTopics,
		});
	},

	updateSocketActiveModule(forceUpdate = false) {
		let activeModule = Application.getCurrentRoute().module || null;

		if (this.lastActiveModule != activeModule || forceUpdate) {
			this.lastActiveModule = activeModule;

			this.socketSend({
				type: 'ACTIVE_MODULE',
				module: activeModule,
			});
		}
	},

	socketSubscribe(topics) {
		topics = [...new Set(topics)].sort();

		if (JSON.stringify(topics) != JSON.stringify(this.socketSubscriptionTopics)) {
			this.socketSubscriptionTopics = topics;
			this.updateSocketSubscriptions();
		}
	},

	refreshSubscriptionsFromDOM() {
		let subs = Array.from(document.querySelectorAll('.js-msgbus'))
			.map(el => el.socketSubscriptions)
			.filter(subs => Array.isArray(subs))
			.flat();

		this.socketSubscribe(subs);
	},

	// }}}
	// {{{ Cards

	'after:show'() {
		this.refreshSubscriptionsFromDOM();
	},

	// }}}
	// {{{ Responsivity

	initResponsivity() {
		this.responsivityQueries = {};
		this.responsivityStatus = {};

		let style = getComputedStyle(document.documentElement);
		// Chrome doesn't return custom properties in the iterator:
		//   https://github.com/w3c/csswg-drafts/issues/1316
		// We need to list them here explicitely
		for (let css_var of ['--vp-width-breakpoint-md']) {
			if (css_var.startsWith('--vp-width-breakpoint-')) {
				let name = css_var.replace('--vp-width-breakpoint-', '');
				let val = style.getPropertyValue(css_var);

				// < rule has -0.02px in CSS, so we add it here too
				this.responsivityQueries['<' + name] = matchMedia(`screen and (max-width: calc(${val} - 0.02px))`);
				this.responsivityQueries['>' + name] = matchMedia(`screen and (min-width: ${val})`);
			}
		}

		this.responsivityQueries.prefers_dark = matchMedia(`(prefers-color-scheme: dark)`);

		for (let [query, match] of Object.entries(this.responsivityQueries)) {
			match.onchange = this.onResponsivityChange.bind(this);
		}

		// cache initial status of queries
		this.onResponsivityChangeDebounced();
	},

	onResponsivityChange(ev) {
		clearTimeout(this.responsivityTimer);
		this.responsivityTimer = setTimeout(() => {
			this.onResponsivityChangeDebounced();
		}, 250);
	},

	onResponsivityChangeDebounced() {
		let status = {};
		for (let [query, match] of Object.entries(this.responsivityQueries)) {
			status[query] = match.matches;
		}
		this.responsivityStatus = status;

		this.updateThemeTinting();

		this.dispatchMessage({type: 'RESPONSIVITY_CHANGE'});
	},

	getResponsivityMatch(query) {
		return this.responsivityStatus[query];
	},

	// }}}
	// {{{ Themes

	updateThemeTinting() {
		if (!document.body) {
			// too soon
			return;
		}

		/*
		 * Determine the current color of the nav header (it's affected by
		 * dark/light mode setting and themes) and set it to mask-icon
		 * and theme-color meta vars.
		 */
		if (!this.sourceHeaderElement) {
			this.sourceHeaderElement = document.body.gwCreateChild({
				style: 'display: none; background-color: var(--nav-header-bg)',
			});
		}

		let themeEl = document.querySelector('meta[name="theme-color"]');
		let maskIconEl = document.querySelector('link[rel="mask-icon"]');
		let targetColor = getComputedStyle(this.sourceHeaderElement).getPropertyValue('background-color');
		if (targetColor) {
			if (themeEl && targetColor !== themeEl.getAttribute('content')) {
				themeEl.setAttribute('content', targetColor);
			}

			if (maskIconEl && targetColor !== maskIconEl.getAttribute('color')) {
				maskIconEl.setAttribute('color', targetColor);
			}
		}
	},

	setDocumentTheme(theme) {
		if (!theme) {
			delete document.documentElement.dataset.theme
			localStorage.removeItem('ui-theme');
		} else {
			document.documentElement.dataset.theme = theme;
			localStorage.setItem('ui-theme', theme);
		}

		this.updateThemeTinting();
	},

	getDocumentTheme() {
		return document.documentElement.dataset.theme;
	},

	// }}}
	// {{{ Language

	setLanguage(lang) {
		document.cookie = 'language=' + lang + '; path=/; max-age=' + (60*60*24*365*5) + ';';
		location.reload();
	},

	// }}}
	// {{{ Version change notification

	serverVersion: env.VERSION,

	detectServerVersionChange(msg) {
		if (msg.type == 'READY' && msg.version != Application.serverVersion) {
			Application.serverVersion = msg.version;

			this.dispatchMessage({
				type: 'VERSION_CHANGE',
			});
		}
	},

	// }}}
	// {{{ Message bus

	busListeners: [],

	watchMessages(cb) {
		this.busListeners.push(cb);
	},

	dispatchMessage(msg) {
		setTimeout(() => {
			let watchers = Array.prototype.slice.call(document.getElementsByClassName('js-msgbus'));

			// deliver socket messages to active components
			for (let el of watchers) {
				if (el.gwComponent && el.gwComponent.onBusMessage) {
					el.gwComponent.onBusMessage(msg);
				}

				el.dispatchEvent(new CustomEvent('busmessage', {
					detail: msg,
				}));
			}

			for (let l of this.busListeners) {
				l(msg);
			}
		}, 0);
	},
	
	// }}}
	// {{{ Common route handling

	async commonRouteHandler(match) {
		//console.log('route', match);
		Performance.pushEvent({
			kind: 'route',
			path: location.pathname + location.search,
		});

		if (!this.session && this.initialLoad) {
			this.initialLoad = false;
			await this.reloadSession();
		}

		if (match.route.group == 'auth' && !this.session) {
			Application.route({
				path: APP_BASE + 'login',
				paramsFn() {
					return new URLSearchParams({
						redirect: location.pathname + location.search,
					});
				},
			});
			return true;
		}

		this.updateSocketActiveModule();

		if (match.route.module && !this.isModuleAllowed(match.route.module)) {
			Application.show({
				id: 'main.accessdeined',
				xtype: 'Main.AccessDeniedScreen',
			});
			return true;
		}
		
		// changing route may change availability of "All groups" items in available group menu
		this.updateAvailableUserGroups();
	},
	
	updateAvailableUserGroups() {
		this.refreshActiveUserGroup();
		this.dispatchMessage({
			type: 'AVAILABLE_GROUPS_CHANGED',
		});
	},

	// }}}
	// {{{ Session

	async reloadSession() {
		let signal = Utils.abortAndRetry(this, 'reload-session');
		let session = await REST.GET('session', null, {signal});
		if (session) {
			this.session = session;

			this.onSessionReady();
		}
		return session;
	},

	isSuperadminUser() {
		return this.session && this.session.user && this.session.user.superadmin;
	},

	isPbxAdminUser() {
		return this.session && this.session.user && this.session.user.pbxadmin;
	},

	getActiveUserGroup() {
		if (this.session) {
			return this.active_user_group;
		}

		return null;
	},
	
	getActiveUserGroups() {
		const active_group = this.getActiveUserGroup();
		if (!active_group) {
			return [];
		}
		if (active_group.id === 'all') {
			return this.getAvailableUserGroups().filter(g => g.id !== 'all');
		}
		return [active_group];
	},

	isDialerApp() {
		const route = Application.getCurrentRoute();
		return ['office', 'agent', 'switchboard'].includes(route.module);
	},	

	isOfficeApp() {
		const route = Application.getCurrentRoute();
		return ['office'].includes(route.module);
	},	

	async setActiveUserGroup(g) {
		if (this.isDialerApp()) {
			await REST.PUT('users/self/dialer-group', {group_id: g});
			// the page is reloaded on socket message SESSION_CHANGED in refreshActiveUserGroup()
		} else {
			localStorage.setItem('user-group-for-' + this.session.user.id, g);
			location.reload();
		}
	},

	refreshActiveUserGroup() {
		/*
		 * app group => set of user groups that can access that app group
		 */
		this.allowed_app_groups_map = new Map;

		if (!this.session || !this.session.user) {
			delete this.active_user_group;
			return;
		}

		for (let g of this.session.user.groups) {
			for (let a of g.enabled_apps) {
				let groups = this.allowed_app_groups_map.get(a);
				if (!groups) {
					groups = new Set;
					this.allowed_app_groups_map.set(a, groups);
				}

				groups.add(g);
			}
		}

		/*
		 * Superadmin is a special case. Superadmin is never a member of
		 * any app group and has access to pre-defined set of apps with
		 * no group switching allowed withing the app.
		 */
		if (this.isSuperadminUser()) {
			this.allowed_app_groups_map = new Map;
			for (let app of ['admin', 'freepbx', 'tts', 'provisioning', 'debug', 'fullcdr', 'summary', 'cdrqos']) {
				this.allowed_app_groups_map.set(app, new Set);
			}
		}

		let avail_groups = this.getAvailableUserGroups();
		
		let dialer_group = this.isDialerApp() && this.session.user.dialer_group_id;
		let stored_group = localStorage.getItem('user-group-for-' + this.session.user.id);

		dialer_group = avail_groups.find(g => g.id == dialer_group);
		stored_group = avail_groups.find(g => g.id == stored_group);

		const old = this.active_user_group;
		this.active_user_group = dialer_group || stored_group || avail_groups[0];
		
		if (old && this.active_user_group && old.id != this.active_user_group.id) {
			// active user group has changed - refresh all data on page, currently by reloading the page

			// avoid network fetch errors due to browser cancelling
			// inflight requests
			Office.QueueManager.end();

			location.reload();
		}
	},

	isAppAllowed(name) {
		let allowed = this.allowed_app_groups_map.has(name) || this.allowed_app_groups_map.has('*');
		if (allowed) {
			return true;
		}

		return false;
	},

	// what groups to show depends on the current module
	getAvailableUserGroups() {
		let no_groups = ['admin', 'outbound'];

		let route = Application.getCurrentRoute();
		if (!route || !route.module) {
			return [];
		}

		if (no_groups.includes(route.module)) {
			return [];
		}

		let groups = this.allowed_app_groups_map.get('*') || this.allowed_app_groups_map.get(route.module);
		if (!groups) {
			return [];
		}

		groups = [...groups];

		if (groups.length > 1) {
			let allowed_by_module = route.module &&
				this.modules.filter(m => m.id == route.module).map(m => m.all_groups_allowed)[0];
			
			let allowed_by_route = route.isAllGroupsAllowed && route.isAllGroupsAllowed(this.routeMatch);
			
			if (allowed_by_route !== undefined ? allowed_by_route : allowed_by_module) {
				groups.unshift({
					id: 'all',
					name: _('Všechny skupiny'),
				});
			}
		}

		return groups;
	},

	onSessionReady() {
		if (!this.socket.isOpen()) {
			this.socket.open();
		}
		this.refreshActiveUserGroup();
		this.updatePageTitle();
		this.refreshActiveExtension();
		this.initDesktopNotifications();
		
		// let the app know about session change
		Application.dispatchMessage({
			type: 'CLIENT_SESSION_CHANGE',
		});
	},

	onUnathorizedError(err) {
		delete this.session;
		this.refreshActiveUserGroup();
		PopupManager.hideAll();
		this.resolveCurrentRoute();
	},

	async login(email, password) {
		this.session = await REST.POST('session', {email, password});

		this.onSessionReady();
	},

	logoutChecks: [],
	logoutActions: [],
	
	async logout() {
		for (let check of this.logoutChecks) {
			if (await check() == 'cancel') {
				return;
			}
		}

		this.socket.close();

		for (let action of this.logoutActions) {
			await action();
		}

		await REST.DELETE('session');
		delete this.session;
		this.refreshActiveUserGroup();

		Application.replaceRoute(APP_BASE);
	},

	// }}}
	// {{{ Extension switching

	refreshActiveExtension() {
		let new_exten = Main.ExtensionSelector.getSelectedExtensionOfUser(Application.session.user);

		if (JSON.stringify(this.activeExtension) != JSON.stringify(new_exten)) {
			this.activeExtension = new_exten;

			this.dispatchMessage({
				type: 'ACTIVE_EXTENSION_SWITCH',
			});
		}
	},

	getSelectedExtension() {
		return this.activeExtension;
	},

	// }}}
	// {{{ Document title

	updatePageTitle() {
		let user = Application.session && Application.session.user;

		if (env.TITLE && user) {
			document.title = env.TITLE
				.replace('%l', user ? user.extension || '---' : '---')
				.replace('%u', user ? user.name : '')
				.replace('%e', user ? user.email : '');
		}
	},

	// }}}
	// {{{ File DnD

	photoDropHandler(ev) {
		let files = [];

		ev.preventDefault();

		if (ev.dataTransfer.items) {
			for (let i = 0; i < ev.dataTransfer.items.length; i++) {
				if (ev.dataTransfer.items[i].kind === 'file') {
					files.push(ev.dataTransfer.items[i].getAsFile())
				}
			}
		} else {
			for (let i = 0; i < ev.dataTransfer.files.length; i++) {
				files.push(ev.dataTransfer.files[i]);
			}
		}

		if (files.length == 0) {
			Application.notify({
				kind: 'error',
				text: _('Nahrát lze pouze fotografie'),
				priority: 5,
				timeout: 3000,
			});  
		} else if (files.length != 1) {
			Application.notify({
				kind: 'error',
				text: _('Nahrát lze jen jedno foto'),
				priority: 5,
				timeout: 3000,
			});  
		} else if (files[0].size > 10000000) {
			Application.notify({
				kind: 'error',
				text: _('Limit velikosti obrázku je 10 MiB.'),
				priority: 5,
				timeout: 3000,
			});  
		} else {
			return files[0];
		}
	},

	// }}}
	// {{{ Browser notifications

	async initDesktopNotifications() {
		if (!window.Notification || Notification.permission !== "default") {
			return;
		}

		try {
			let permission = await Notification.requestPermission();
			if (permission === "denied") {
				Application.notify({
					kind: 'warning',
					text: _('Bez povolených notifikací si nemusíte všimnout hovorů pokud máte okno na pozadí. Notifikace si můžete v budoucnu zapnout ručně.'),
					timeout: 5000,
				});
			}
		} catch (ex) {
			console.log(ex);
		}
	},

	desktopNotificationsBlocked() {
		return window.Notification && Notification.permission === "denied";
	},

	desktopNotification(config) {
		if (!window.Notification || Notification.permission !== "granted") {
			return;
		}

		if (config.backgroundOnly && document.visibilityState === 'visible') {
			return;
		}

		let lang = i18n.LANGUAGES.find(l => l.id == i18n.lang);
		let n = new Notification(config.title, {
			lang: lang ? lang.lang : 'cs-CZ',
			body: config.text,
			requireInteraction: true,
			badge: APP_BASE + 'fav/android-chrome-192x192.png',
			icon: APP_BASE + 'fav/android-chrome-192x192.png',
		});

		n.config = config;

		n.onclose = ev => {
			this.activeDesktopNotifications.delete(n);
		};

		n.onerror = ev => {
			this.activeDesktopNotifications.delete(n);
		};

		/*
		n.onclick = ev => {
			console.log('action', ev);
		};
		*/

		if (!this.activeDesktopNotifications) {
			this.activeDesktopNotifications = new Set;
		}

		this.activeDesktopNotifications.add(n);

		return n;
	},

	closeDesktopNotifications(filterFn) {
		if (!this.activeDesktopNotifications) {
			return;
		}

		for (let n of this.activeDesktopNotifications) {
			if (filterFn && !filterFn(n.config)) {
				continue;
			}

			try {
				n.close();
			} catch (ex) {
				console.log(ex);
			}
		}
	},

	onDocumentVisibilityChange() {
		if (document.visibilityState === 'visible') {
			this.closeDesktopNotifications();
		}
	},

	// }}}
	// {{{ Application modules

	modules: [],

	registerModule(m) {
		this.modules.push(m);
	},

	getAllowedModules() {
		return this.modules.filter(m => this.isAppAllowed(m.access || m.id));
	},

	isModuleAllowed(mod_name) {
		return this.getAllowedModules().some(m => m.id == mod_name);
	},

	// }}}
	// {{{ MEI

	async handleMEI() {
		let audio = document.body.gwCreateChild({
			nodeName: 'audio',
			src: '/audio/noise.mp3',
			loop: true,
		});

		this.audioBlocked = null;

		let handle = ev => {
			document.removeEventListener('click', handle);

			this.audioBlocked = false;

			Application.dispatchMessage({
				type: 'AUDIO_BLOCK_CHANGE',
			});
		}

		try {
			await audio.play();

			setTimeout(() => audio.remove(), 100);
			this.audioBlocked = false;

			Application.dispatchMessage({
				type: 'AUDIO_BLOCK_CHANGE',
			});
		} catch (ex) {
			Performance.pushEvent({
				kind: 'audio autoplay test failed',
				err: ex.message,
			});

			audio.remove();

			this.audioBlocked = true;
			document.addEventListener('click', handle);

			Application.dispatchMessage({
				type: 'AUDIO_BLOCK_CHANGE',
			});
		}
	},

	// }}}
	// {{{ App startup

	'before:run'() {
		let theme = localStorage.getItem('ui-theme');
		if (theme && ['light', 'dark'].includes(theme)) {
			document.documentElement.classList.toggle('no-transitions', true);
			document.documentElement.dataset.theme = theme;
			requestAnimationFrame(() => {
				document.documentElement.classList.toggle('no-transitions', false);
			});
		}

		// Removes meta "theme-color" from HTML head as soon as possible
		// to prevent flickering of Safari color tinting while using
		// non-default theme
		const metaThemeColorElement = document.querySelector('meta[name="theme-color"]');
		if (metaThemeColorElement) {
			metaThemeColorElement.setAttribute('content', '');
		}

		document.addEventListener('visibilitychange', this.onDocumentVisibilityChange.bind(this));

		this.updateThemeTinting();
		this.handleMEI();
	},

	// }}}
});

// {{{ Performance monitor

function IndexedDBLog(name, limit = 5000) {
	let db;
	let queue = [];

	function log(o) {
		if (!db) {
			queue.push(o);
			return;
		}

		try {
			let tr = db.transaction(['entries'], 'readwrite');
			let store = tr.objectStore('entries');

			store.add(o);
		} catch (ex) {
			console.error('IndexedDBLog.log() failed:', o, ex);
		}
	}

	function query() {
		return new Promise((resolve, reject) => {
			let tr = db.transaction(['entries'], 'readonly');
			let store = tr.objectStore('entries');
			let req = store.getAll();

			req.onsuccess = ev => {
				resolve(ev.target.result);
			};

			req.onerror = ev => {
				reject(new Error('Query failed'));
			};
		});
	}

	function gc(keepCount = 1000) {
		/*
		 * We need to get the min key value that we want to keep, and
		 * then delete all the remaining entries with keys that have
		 * lower value.
		 */
		return new Promise((resolve, reject) => {
			if (!db) {
				return resolve();
			}

			let tr = db.transaction(['entries'], 'readwrite');
			let store = tr.objectStore('entries');

			let allKeys = store.getAllKeys();
			allKeys.onsuccess = ev => {
				if (allKeys.result.length <= keepCount) {
					resolve();
					return;
				}

				let minKey = allKeys.result[allKeys.result.length - keepCount]

				let deleteStale = store.delete(IDBKeyRange.upperBound(minKey, true));
				deleteStale.onsuccess = ev => {
					resolve();
				};

				deleteStale.onerror = ev => {
					reject(new Error('Delete failed'));
				};
			};

			allKeys.onerror = ev => {
				reject(new Error('Get all keys failed'));
			};
		});
	}

	function clear() {
		return new Promise((resolve, reject) => {
			queue = [];

			if (!db) {
				return resolve();
			}

			let tr = db.transaction(['entries'], 'readwrite');
			let store = tr.objectStore('entries');

			let req = store.clear();
			req.onsuccess = ev => {
				resolve();
			};

			req.onerror = ev => {
				reject(new Error('Delete failed'));
			};
		});
	}

	let r = indexedDB.open(name, 1);

	r.onerror = ev => {
		console.log('IndexedDBLog: open of DB ' + name + ' failed: ', ev);
	};

	r.onsuccess = ev => {
                // update module reference to db and start logging to DB
		db = ev.target.result;

		// flush the queue to DB
		for (let o of queue) {
			log(o);
		}
	};

	r.onupgradeneeded = ev => {
		let db = ev.target.result;

		db.createObjectStore('entries', {
			autoIncrement: true,
		});
	};

	setInterval(() => {
		gc(limit).catch(console.error);
	}, 30000);

	return {
		log,
		query,
		clear,
	};
}

Performance = {
	init() {
		this.tabid = btoa(String.fromCodePoint(...crypto.getRandomValues(new Uint8Array(6))))
			.replace(/=/g, '').replace(/\//g, '_').replace(/\+/g, '$');

		this.records = IndexedDBLog('perf-records');

		addEventListener('beforeunload', ev => {
			Performance.pushEvent({
				kind: 'page unload',
				ua: navigator.userAgent,
			});
		});

		Performance.pushEvent({
			kind: 'page load',
			ua: navigator.userAgent,
		});

		document.addEventListener('visibilitychange', () => {
			Performance.pushEvent({
				kind: 'page visibility',
				state: document.visibilityState,
			});
		});
	},

	pushEvent(ev) {
		this.records.log({
			tid: this.tabid,
			ts: new Date,
			...ev,
		});
	},

	summarizeRTCStats(s) {
		let rec_map = new Map(s.map(r => [r.id, r]));

		function candidate_to_string(c) {
			if (c && c.type == 'remote-candidate') {
				return c.candidateType + ':' + c.protocol + ':' + c.address + ':' + c.port;
			} else if (c && c.type == 'local-candidate') {
				return c.candidateType + ':' + c.protocol + ':' + c.address + ':' + c.port;
			}

			return null;
		}

		let selected_pairs = s.filter(r => r.type == 'candidate-pair' && r.selected)
			.map(r => {
				return {
					local: candidate_to_string(rec_map.get(r.localCandidateId)),
					remote: candidate_to_string(rec_map.get(r.remoteCandidateId)),
				};
			});

                function mapCodec(r) {
			if (r.codecId) {
				r.codec = rec_map.get(r.codecId);
				if (r.codec) {
					delete r.codec.id;
					delete r.codec.timestamp;
					delete r.codec.type;
					delete r.codec.transportId;
				}

				delete r.codecId;
			}
		}

		let rtps = s.filter(r => r.type == 'inbound-rtp' || r.type == 'outbound-rtp').map(r => {
			delete r.id;
			delete r.trackIdentifier;
			mapCodec(r);

			if (r.remoteId) {
				r.remote = rec_map.get(r.remoteId);
				if (r.remote) {
					delete r.remote.id;
					delete r.remote.localId;
					delete r.remote.timestamp;
					delete r.remote.type;
					delete r.remote.remoteTimestamp;

					mapCodec(r.remote);
				}

				delete r.remoteId;
			}

			return r;
		});

		return {
			selected_pairs,
			rtps,
		};
	},

	pushSessionUpdate(up) {
		up = {
			kind: 'session',
			...up,
		};

		function candidate_to_string(c) {
			if (c && c.type == 'remote-candidate') {
				return c.candidateType + ':' + c.protocol + ':' + c.address + ':' + c.port;
			} else if (c && c.type == 'local-candidate') {
				return c.candidateType + ':' + c.protocol + ':' + c.address + ':' + c.port;
			}

			return null;
		}

		if (Array.isArray(up.stats)) {
			let rec_map = new Map(up.stats.map(r => [r.id, r]));
			let selected = new Set(up.stats.filter(r => r.type == 'transport' && r.selectedCandidatePairId).map(r => r.selectedCandidatePairId));
			let candidates = up.stats.filter(r => r.type == 'candidate-pair')
				.map(r => {
					return {
						state: r.state,
						is_selected: selected.has(r.id),
						local: candidate_to_string(rec_map.get(r.localCandidateId)),
						remote: candidate_to_string(rec_map.get(r.remoteCandidateId)),
					};
				});

			delete up.stats;

			if (up.msg == 'ice agent') {
				up.candidates = candidates;
			}
		}

		if (up.msg == 'ice agent' && up.state == 'ice slow') {
			REST.POST('log', up).catch(console.log);
		}

		this.pushEvent(up);
	},

	pushRTCStats(call) {
                call.stats = this.summarizeRTCStats(call.stats);

		REST.POST('perf/session-stats', call).catch(console.log);

		this.pushEvent({
			kind: 'session-stats',
			...call,
		});
	},

	async sendRecords() {
		let records = await this.records.query();

		await REST.POST('perf/records', {
			cid: Application.socket.cid,
			tid: this.tabid,
			ua: navigator.userAgent,
			records,
		});
	},

	async clearRecords() {
		await this.records.clear();
	},
};

Performance.init();

REST.reportPerformance = function(start_ts, server_timing, info) {
	let sd = Number(server_timing);
	if (!isFinite(sd)) {
		sd = null;
	}

	if (info.path == 'perf/records') {
		return;
	}

	Performance.pushEvent({
		kind: 'rest-api',
		cd: performance.now() - start_ts,
		sd,
		...info,
	});
};

Application.watchMessages(async msg => {
	if (msg.type == 'PERF_REQUEST_RECORDS') {
		Performance.sendRecords().catch(console.log);
	} else if (msg.type == 'PERF_CLEAR_RECORDS') {
		Performance.clearRecords();
	}
});

// }}}

// Public screens:

// {{{ Pubweb.PublicScreen

GW.define('Pubweb.PublicScreen', 'GW.Component', {
	title: APP_NAME,
	subtitle: '',

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'public-screen',
			children: [{
				ref: 'headerEl',
				className: 'header',
				children: [{
					ref: 'logoEl',
					className: 'logo',
					children:[Utils.useIcon('logo', {cls: 'logo'})]
				}, {
					':skip': !this.subtitle,
					nodeName: 'h2',
					textContent: this.subtitle,
				}],
			}, {
				ref: 'bodyEl',
				className: 'body',
			}, {
				ref: 'footerEl',
				className: 'footer',
			}],
		}, this);
	},
});

// }}}
// {{{ Pubweb.MessageScreen

GW.define('Pubweb.MessageScreen', 'Pubweb.PublicScreen', {
	title: '',
	message: '',
	buttonText: '',
	kind: 'info',

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([...this.getMessages(), {
			className: 'form-buttons',
			children: this.getButtons(),
		}]);
	},

	getMessages() {
		return [{
			nodeName: 'p',
			className: this.kind,
			textContent: this.message,
		}];
	},

	getButtons() {
		return [{
			nodeName: 'button',
			className: 'primary',
			textContent: this.buttonText,
			'on:click': ev => this.onButtonClick(),
		}];
	},

	onButtonClick() {
	},
});

// }}}
// {{{ Pubweb.FormScreen

GW.define('Pubweb.FormScreen', 'Pubweb.PublicScreen', {
	submitText: _('Potvrdit'),

	'after:initComponent'() {
		let links = this.getFormLinks();

		this.bodyEl.gwCreateChild({
			nodeName: 'form',
			noValidate: true,
			'on:submit': ev => {
				ev.preventDefault();
				this.onSubmit();
			},
			className: 'form',
			children: [...this.getFormFields(), {
				className: 'form-message',
				ref: 'formMessage'
			}, {
				className: 'form-buttons',
				children: this.getFormButtons(),
			}, {
				className: 'form-links' + (links.length == 0 ? ' hidden' : ''),
				children: links,
			}],
		}, this);

		setTimeout(() => this.focus(), 0);
	},

	getFormFields() {
		return [];
	},

	getFormButtons() {
		return [{
			nodeName: 'button',
			className: 'primary',
			textContent: this.submitText,
		}];
	},

	getFormLinks() {
		return [];
	},

	focus() {
		for (let f of this.el.querySelectorAll('input,select,textarea')) {
			if (!f.disabled) {
				f.focus();
				break;
			}
		}
	},

	showError(text) {
		this.formMessage.gwReplaceChildren([Utils.useIcon('alertcirclefull'), text]);
	},

	hideError() {
		this.formMessage.textContent = '';
	},

	async onSubmit() {
		this.hideError();

		if (!this.validateForm()) {
			this.showError(_('Prosíme vyplňte formulář správně.'));
			return;
		}

		let data = this.getFormFieldsData();
		let restore = this.setFormDisabled();

		try {
			await this.onSave(data);
		} catch(ex) {
			restore();
			this.showError(ex.message);
		}
	},

	async onSave(data) {
	},

	...FormMixin,
});

// }}}
// {{{ Pubweb.LoginScreen

GW.define('Pubweb.LoginScreen', 'Pubweb.FormScreen', {
	subtitle: _('Přihlášení'),
	submitText: _('Přihlásit'),

	getFormFields() {
		return [{
			xtype: 'TextField',
			name: 'email',
			type: 'email',
			label: _('E-mail'),
			autocomplete: 'username'
		}, {
			xtype: 'PasswordTextField',
			name: 'password',
			enforcePasswordRules: false,
			label: _('Heslo'),
			autocomplete: 'current-password'
		}];
	},

	getFormLinks() {
		return [];

		/*
		//XXX: not yet
		return [{
			nodeName: 'a',
			href: APP_BASE + 'resetpw',
			textContent: _('Nevíte heslo?'),
		}];
		*/
	},

	async onSave(data) {
		let params = new URLSearchParams(location.search);
		let ref = params.get('redirect');

		await Application.login(data.email, data.password);

		if (ref) {
			if (ref.match(/^\/{0,}api\//)) {
				ref = APP_BASE;
			}
		} else {
			ref = APP_BASE;
		}

		Application.replaceRoute(ref);
	},
});

// }}}
// {{{ Pubweb.ResetPasswordStart

GW.define('Pubweb.ResetPasswordStart', 'Pubweb.FormScreen', {
	submitText: _('Zaslat odkaz'),

	getFormFields() {
		return [{
			nodeName: 'h2',
			textContent: _('Reset hesla'),
		}, {
			nodeName: 'p',
			textContent: _('Na Váš e-mail Vám zašleme odkaz na stránku, kde si budete moci nastavit nové heslo.'),
		}, {
			xtype: 'TextField',
			name: 'email',
			type: 'email',
			label: _('Váš e-mail'),
		}];
	},

	getFormLinks() {
		return [{
			nodeName: 'a',
			href: APP_BASE,
			textContent: _('Přihlášení'),
		}];
	},

	async onSave(data) {
		await REST.POST('password-reset', data);

		Application.show({
			xtype: 'Pubweb.MessageScreen',
			title: _('Odkaz byl zaslán'),
			message: _('Zkontrolujte si poštu (včetně spamu) a nastavte si nové heslo pomocí odkazu ve zprávě, kterou jsme Vám zaslali.'),
			buttonText: _('Rozumím'),
			onButtonClick() {
				Application.pushRoute(APP_BASE);
			},
		});
	},
});

// }}}
// {{{ Pubweb.ResetPasswordFinish

GW.define('Pubweb.ResetPasswordFinish', 'Pubweb.FormScreen', {
	submitText: _('Nastavit nové heslo'),

	getFormFields() {
		return [{
			nodeName: 'h2',
			textContent: _('Nové heslo'),
		}, {
			ref: 'msgEl',
			nodeName: 'p',
		}, {
			xtype: 'PasswordTextField',
			name: 'password',
			label: _('Nové heslo'),
		}];
	},

	getFormLinks() {
		return [{
			nodeName: 'a',
			href: APP_BASE,
			textContent: _('Přihlášení'),
		}];
	},

	async onSave(data) {
		await REST.POST('password-reset/' + this.skey + '/perform', data);

		Application.show({
			xtype: 'Pubweb.MessageScreen',
			title: _('Heslo změněno'),
			message: _('Nyní se můžete přihlásit s použitím Vašeho nového hesla.'),
			buttonText: _('Rozumím'),
			onButtonClick() {
				Application.pushRoute(APP_BASE);
			},
		});
	},

	async activate() {
		setTimeout(() => {
			this.setFormFieldsData({password: ''});
		}, 100);

		let restore = this.setFormDisabled();

		try {
			let status = await REST.GET('password-reset/' + this.skey);
			if (status.status == 'expired') {
				this.msgEl.textContent = _('Reset hesla již nelze provést. Platnost odkazu vypršela.');
			} else if (status.status == 'okay') {
				this.msgEl.textContent = _('Zadejte nové heslo pro váš účet: {email}.')
					.replace('{email}', status.email + ' (' + status.name + ')');
				restore();
			} else {
				this.msgEl.textContent = _('Neznámá chyba.');
			}
		} catch (ex) {
			this.msgEl.textContent = ex.message;
		}
	},
});

// }}}
// {{{ Pubweb.RegisterScreen

GW.define('Pubweb.RegisterScreen', 'Pubweb.FormScreen', {
	submitText: _('Registrovat se'),

	getFormFields() {
		return [{
			nodeName: 'h2',
			textContent: _('Dokončit registraci'),
		}, {
			ref: 'msgEl',
			nodeName: 'p',
		}, {
			xtype: 'PasswordTextField',
			name: 'password',
			label: _('Nové heslo'),
		}];
	},

	async onSave(data) {
		await REST.POST('registrations/finish', {
			...data,
			access_code: this.skey,
		});

		Application.show({
			xtype: 'Pubweb.MessageScreen',
			title: _('Registrace dokončena'),
			message: _('Nyní se můžete přihlásit s použitím Vašeho nového hesla.'),
			buttonText: _('Rozumím'),
			onButtonClick() {
				Application.pushRoute(APP_BASE);
			},
		});
	},

	async activate() {
		let restore = this.setFormDisabled();

		try {
			let status = await REST.POST('registrations/status', {access_code: this.skey});

			this.msgEl.textContent = _('Pro dokončení registrace zadejte své telefonní číslo a nové heslo pro Váš účet: {email}.')
				.replace('{email}', status.email);
			restore();

			setTimeout(() => {
				this.setFormFieldsData({
					password: '',
				});
			}, 100);
		} catch (ex) {
			Application.show({
				xtype: 'Pubweb.MessageScreen',
				title: _('Registrace selhala'),
				message: ex.message,
				kind: 'error',
				buttonText: _('Rozumím'),
				onButtonClick() {
					Application.pushRoute(APP_BASE);
				},
			});
		}
	},
});

// }}}
// {{{ Pubweb.Routes

Application.addRoutes([{
	group: 'public',
	path: APP_BASE + 'login',
	async handler({params}) {
		Application.show({
			id: 'admin.login',
			xtype: 'Pubweb.LoginScreen',
		});
	}    
}, {
	group: 'public',
	path: APP_BASE + 'register/{skey:str}',
	async handler({params, captures}) {
		Application.show({
			id: 'admin.register',
			xtype: 'Pubweb.RegisterScreen',
			skey: captures.skey,
		});
	}    
}, {
	group: 'public',
	path: APP_BASE + 'resetpw',
	async handler({params}) {
		Application.show({
			id: 'admin.resetpw.start',
			xtype: 'Pubweb.ResetPasswordStart',
		});
	}    
}, {
	group: 'public',
	path: APP_BASE + 'resetpw/{skey:str}',
	async handler({params, captures}) {
		Application.show({
			id: 'admin.resetpw.finish',
			xtype: 'Pubweb.ResetPasswordFinish',
			skey: captures.skey,
		});
	}    
}]);

// }}}

// Main app:

// {{{ Main.Timecard

GW.define('Main.Timecard', 'GW.Component', {
	startTime: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			'attr:data-running': false,
			children: [{
				className: 'status-icon',
			}, {
				className: 'status-time',
				children: [{
					ref: 'timeHours',
					textContent: '00',
					nodeName: 'span',
				}, {
					className: 'blinking',
					textContent: ':',
					nodeName: 'span',
				}, {
					ref: 'timeMinutes',
					textContent: '00',
					nodeName: 'span',
				}],
			}, {
				ref: 'toggle',
				nodeName: 'button',
				className: 'secondary small',
				type: 'button',
				textContent: _("Zahájit práci"),
				disabled: true,
				'on:click': ev => {
					ev.preventDefault();

					if (this.startTime) {
						this.end();
					} else {
						this.start();
					}
				},
			}],
		}, this);

		this.loadState();
		Utils.alignedTimer(this, 'midnight', 'day', 5000, () => this.loadState());
	},

	onBusMessage(msg) {
		if (msg.type == "TIMECARD_CHANGED") {
			this.loadState();
		}
	},

	async loadState() {
		const signal = Utils.abortAndRetry(this, 'state');
		const state = await REST.GET('users/self/timecard', null, {signal});

		this.toggle.disabled = false;

		this.startTime = state.start_ts ? new Date(state.start_ts) : null;
		this.el.dataset.running = !!this.startTime;

		this.sum = state.sum;

		if (this.startTime) {
			this.toggle.textContent = _("Ukončit práci");

			Utils.interval(this, 'updateTimer', 1000, () => this.updateTimer());
		} else {
			this.toggle.textContent = _("Zahájit práci");

			Utils.abortInterval(this, 'updateTimer');
		}

		this.updateTimer();
	},

	async start() {
		await REST.POST('users/self/timecard/start', {
			cid: Application.socket?.cid,
		});

		await this.loadState();
	},

	updateTimer() {
		const msecs = (this.startTime ? new Date() - this.startTime : 0) + this.sum * 1000;
		const [hours, minutes] = Formats.duration_short(msecs).split(':');

		this.timeHours.textContent = hours;
		this.timeMinutes.textContent = minutes;
	},

	async end() {
		await REST.POST('users/self/timecard/stop', {
			cid: Application.socket?.cid,
		});

		await this.loadState();
	}
});

// }}}
// {{{ Main.ExtensionSelector

GW.define('Main.ExtensionSelector', 'SelectField', {
	cls: 'small external-exten-selection js-msgbus',
	placeholder: _('Vyberte linku...'),

	popupAutoWidth: false,
	
	userId: null,

	'after:initComponent'() {
		this.refreshSelected();
		if (!this.userId) {
			console.warn('userId is required for ExtensionSelector, loading and setting extension will not work');
		}
	},

	formatOption(e) {
		if (!e) {
			return null;
		}
		
		function option_title(title, name) {
			return title + (name ? ' - ' + name : '');
		}

		let text, popup_text;
		if (e.type == 'default') {
			text = option_title(_('Interní linka'), e.exten);
		} else if (e.type == 'external') {
			text = option_title(_('Externí linka'), e.exten);
		} else if (e.type == 'freeseat') {
			text = option_title(_('Freeseating') + ' - ' + e.exten);
			popup_text = option_title(_('Freeseating') + ' - ' + e.exten, e.owner && e.owner.name);
		}

		return {
			value: e.type + '-' + e.exten,
			popup_text,
			text,
			cls: e.type,
			exten: e.exten,
		};
	},
	
	async getOptions({signal}) {
		let extens = await REST.GET('users/' + this.userId + '/extensions', null, {signal});

		let opts = extens.map(e => this.formatOption(e));
		let first_freeseat_idx = extens.findIndex(e => e.type == 'freeseat');
		if (first_freeseat_idx > 0) {
			opts.splice(first_freeseat_idx, 0, {
				render: {
					nodeName: 'hr',
				},
			});
		}

		return opts;
	},

	async onOptionSelect(o) {
		this.setDisabled(true);
		this.setSelectedOption(o);

		await REST.PUT('users/' + this.userId + '/extension', {exten: o.exten});
		
		// intentionally no setDisabled(false) - wait to refreshSelected() to be called or component refresh
		// to confirm the selection and show new selected extension
	},

	// to be implemented in inherited component
	// - return currently selected extension as {type: 'default' | 'external' | 'freeseat', exten: string}|null
	getCurrentExtension() {
		throw 'not implemented';
	},

	refreshSelected() {
		this.setSelectedOption(this.formatOption(this.getCurrentExtension()));
		this.setDisabled(false);
	}

});
Main.ExtensionSelector.getSelectedExtensionOfUser = user => {
	if (user == null || user.extension == null) {
		return null;
	}
	if (user.followme) {
		return {
			type: 'external',
			exten: user.followme,
		};
	}
	return {
		type: user.extension == user.default_extension ? 'default' : 'freeseat',
		exten: user.extension,
	};
}

GW.define('Main.SelfExtensionSelector', 'Main.ExtensionSelector', {
	cls: 'small inverted external-exten-selection js-msgbus',
	userId: 'self',

	getCurrentExtension() {
		return Application.getSelectedExtension();
	},

	onBusMessage(msg) {
		if (msg.type == 'ACTIVE_EXTENSION_SWITCH') {
			this.refreshSelected();
		}
	},

});

// }}}
// {{{ Main.ModulesSelector

GW.define('Main.ModulesSelector', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'module-chooser',
			children: this.getAppModules().map(m => this.renderModule(m)),
			'on*:click': ev => {
				if (ev.target.closest('a')) {
					PopupManager.hideAll();
				}
			},
		});
	},

	getAppModules() {
		return [{
			id: 'modules',
			title: _('Rozcestník'),
			tagline: _('Kontaktní centrum'),
			icon: 'home',
			href: '/',
		}, ...Application.getAllowedModules()];
	},

	renderModule(m) {
		return {
			className: 'module',
			nodeName: 'a',
			href: m.href,
			target: m.href_target,
			children: [{
				className: 'logo',
				children: [Utils.useIcon(m.icon || 'phone')],
			}, {
				className: 'info',
				children: [{
					className: 'title',
					textContent: m.title,
				}, {
					className: 'tagline',
					textContent: m.tagline,
				}],
			}],
		};
	},
});

// }}}
// {{{ Main.Screen

GW.define('Main.Screen', 'GW.Component', {
	enableExtenSelector: false,

	initComponent() {
		let user = Application.session && Application.session.user;

		this.el = document.gwCreateElement({
			className: 'main-screen js-msgbus',
			children: [{
				ref: 'headerEl',
				className: 'header',
				children: [{
					className: 'modules',
					ref: 'modulesEl',
					children: [Utils.useIcon('apps')],
					'on:click': ev => this.showModulesPopup(ev),
				}, {
					className: 'logo',
					ref: 'logoEl',
					children: [Utils.useIcon('logo')],
					'on:click': ev => Application.replaceRoute(APP_BASE),
				}, {
					className: 'title',
					ref: 'titleEl',
					children: [(this.titleIcon ? Utils.useIcon(this.titleIcon) : undefined), this.title],
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'nav-mobile-expander button icon-left transparent',
					children: [Utils.useIcon('phone')],
					'on:click': () => this.headerEl.classList.toggle('expanded'),
				}, {
					className: 'nav-mobile-expand',
					children: [{
						':skip': !Application.session.user?.using_timecards,
						xtype: 'Main.Timecard',
					}, {
						':skip': !this.enableExtenSelector,
						xtype: 'Main.SelfExtensionSelector',
					}, {
						className: 'group-selection js-msgbus',
						ref: 'groupSelection',
						'on:busmessage': ev => {
							let msg = ev.detail;
							if (msg.type == 'AVAILABLE_GROUPS_CHANGED' || msg.type == 'CALL_MANAGER_CHANGE') {
								this.renderActiveUserGroupSelector();
							}
						},
					}]
				}, {
					':skip': !(Application.session && Application.session.bugreports_enabled),
					nodeName: 'button',
					type: 'button',
					className: 'report-bug button icon-only small transparent',
					children: [Utils.useIcon('bug')],
					title: _('Nahlásit problém'),
					'on:click': () => this.reportIssue(),
				}, {
					className: 'server-status',
					ref: 'serverStatus',
				}, {
					className: 'app-status js-msgbus hidden',
					ref: 'appStatus',
					children: [{
						ref: 'appStatusBtn',
						className: 'warning icon-left small',
						nodeName: 'button',
						children: [Utils.useIcon('download'), {
							className: 'text',
							textContent: _('Načíst novou verzi'),
						}],
						'on:click': ev => location.reload(),
					}],
					'on:busmessage': ev => {
						let msg = ev.detail;
						if (msg.type == 'VERSION_CHANGE') {
							this.updateAppStatus();
						}
					},
				}, {
					ref: 'userProfileEl',
					className: 'profile',
					children: [{
						className: 'icon',
					}, {
						className: 'name',
						ref: 'userNameEl',
					}],
					'on:click': ev => this.showProfilePopup(ev),
				}],
			}, {
				ref: 'bodyEl',
				className: 'body page-centered-container',
			}, {
				ref: 'sidebarEl',
				className: 'sidebar hidden',
			}, {
				ref: 'footerEl',
				className: 'footer hidden',
			}],
		}, this);

		this.userNameEl.textContent = user ? user.name : '';
		this.userProfileEl.gwHide(!user);

		this.updateSidebarMenu();
		this.renderActiveUserGroupSelector();
		this.updateAppStatus();
	},

	updateAppStatus() {
		if (Application.serverVersion != env.VERSION) {
			this.appStatus.classList.remove('hidden');
			this.appStatusBtn.title =
				_('Aplikace byla aktualizována na verzi {version}, je třeba obnovit stránku pro dokončení aktualizace.')
					.replace('{version}', Application.serverVersion);
		}
	},

	reportIssue() {
		new Main.FormDialog({
			title: _('Nahlásit problém'),
			subtitle: _('Technické problémy s hovory je dobré hlásit do několika minut po skončení problematického hovoru či situace. K hlášení se automaticky připojuje záznam posledních aktivit v aplikaci a ten při pozdním hlášení již nemusí být aktuální.'),

			renderFormFields() {
				return [{
					xtype: 'TextareaField',
					label: _('Popište krátce problém'),
					optional: true,
					name: 'message',
				}];
			},

			async onSave(data) {
				let records = await Performance.records.query();
				let message = data.message;

				await REST.POST('perf/bugreport', {
					ts: new Date,
					message,
					cid: Application.socket.cid,
					ua: navigator.userAgent,
					records,
				});

				Application.notify({
					kind: 'info',
					text: _('Děkujeme za hlášení'),
				});
			},
		});
	},

	renderActiveUserGroupSelector() {
		let g = Application.getActiveUserGroup();
		let groups = Application.getAvailableUserGroups();
		if (groups.length == 0) {
			this.groupSelection.textContent = '';
			return;
		}
		
		// changing dialer group during causes a page refresh and the call is lost
		let in_call = !!Office.CallManager.getState().active_call;

		this.groupSelection.gwReplaceChildren([{
			xtype: 'SelectField',
			cls: 'small inverted',
			popupAutoWidth: false,
			disabled: groups.length == 1 || in_call,
			title: in_call ? _('Nelze změnit skupinu během probíhajícího hovoru') : undefined,
			options: groups.map(g => {
				return {
					value: g.id,
					text: g.name,
				};
			}),
			value: g && g.id,
			'on:change': async c => {
				try {
					await Application.setActiveUserGroup(c.getValue());
				} catch (e) {
					// revert value if group change failed
					c.setValue(g.id);
					throw e;
				}
			},
		}]);
	},
	
	

	showModulesPopup(ev) {
		let modsEl = ev.target.closest('.modules');
		let popup = new Main.ModulesSelector();

		PopupManager.show(popup, {
			fixed: true,
			top: this.headerEl.offsetHeight,
			left: 0,
			toggleEl: modsEl,
		});
	},

	getSidebarMenu() {
		return [];
	},

	//XXX: call on activate() to update selected item
	updateSidebarMenu() {
		let menu = this.getSidebarMenu();
		if (menu.length == 0) {
			return;
		}

		this.sidebarEl.gwCreateChild({
			className: 'vertical-menu',
			children: menu,
		});

		this.sidebarEl.classList.remove('hidden');

		for (let a of this.sidebarEl.querySelectorAll('a')) {
			let match = Application.routePath.startsWith(a.getAttribute('href') + '/')
				|| Application.routePath == a.getAttribute('href');

			a.classList.toggle('active', match);
		}
	},

	getProfileOptions() {
		function setTheme(theme) {
			Application.setDocumentTheme(theme);
			PopupManager.hideAll();
		}

		return [{
			iconName: 'user',
			text: Application.session.user.name,
			cls: 'name'
		}, {
			render: {
				className: 'option separator',
			}
		}, {
			hidden: Application.session.user.external,
			iconName: 'pencil',
			text: _('Změnit heslo'),
			handle: c => this.showPasswordChangeDialog(),
		}, {
			iconName: 'globe',
			text: _('Jazyk'),
			submenu: i18n.LANGUAGES.map(l => {
				return {
					rightIconName: l.id == i18n.lang ? 'check' : null,
					cls: l.id == i18n.lang ? 'active' : undefined,
					text: l.name,
					handle: () => Application.setLanguage(l.id),
				};
			}),
		}, {
			iconName: 'moon',
			text: _('Vzhled'),
			submenu: [{
				rightIconName: !Application.getDocumentTheme() ? 'check' : null,
				cls: !Application.getDocumentTheme() ? 'active' : undefined,
				iconName: 'sunmoon',
				text: _('Automatický'),
				handle: () => setTheme(),
			}, {
				rightIconName: Application.getDocumentTheme() == 'light' ? 'check' : null,
				cls: Application.getDocumentTheme() == 'light' ? 'active' : undefined,
				iconName: 'sun',
				text: _('Světlý motiv'),
				handle: () => setTheme('light'),
			}, {
				rightIconName: Application.getDocumentTheme() == 'dark' ? 'check' : null,
				cls: Application.getDocumentTheme() == 'dark' ? 'active' : undefined,
				iconName: 'moon',
				text: _('Tmavý motiv'),
				handle: () => setTheme('dark'),
			}],
		}, {
			id: 'notifications',
			iconName: 'comment',
			text: _('Zapnout notifikace'),
			handle: c => {
				if (Application.desktopNotificationsBlocked()) {
					Application.notify({
						kind: 'error',
						text: _('Notifikace máte zablokovné v prohlížeči. Nejprve je musíte odblokovat.'),
					});
				} else {
					Application.initDesktopNotifications();
				}
			},
		}, {
			render: {
				className: 'option separator',
			},
		}, {
			hidden: !(Application.session && Application.session.bugreports_enabled),
			iconName: 'bug',
			text: _('Nahlásit problém'),
			handle: e => {
				this.reportIssue();
			},
		}, {
			iconName: 'bookopen',
			text: _('Dokumentace'),
			handle: e => {
				window.open(APP_BASE + 'docs', '_blank');
			},
		}, {
			iconName: 'informationcircle',
			text: _('O aplikaci'),
			handle: c => this.showAboutDialog(),
		}, {
			render: {
				className: 'option separator',
			},
		}, {
			iconName: 'logout',
			text: _('Odhlásit'),
			handle: async c => {
				await Application.logout();
			},
		}];
	},

	showProfilePopup(ev) {
		let popup = new PopupMenu({
			options: this.getProfileOptions(),

			'after:initComponent'() {
				this.el.classList.add('profile-popup');
			},
		});

		PopupManager.show(popup, {
			anchorEl: ev.target.closest('.profile'),
			forceAxis: 'vertical',
			preferReadingOrder: true,
		});
	},

	async showAboutDialog() {
		let ver = await REST.GET('version');

		new Main.Dialog({
			title: _('O aplikaci'),

			'after:initComponent'() {
				this.bodyEl.classList.add('main-about-dialog');
				this.bodyEl.gwReplaceChildren([{
					nodeName: 'h4',
					textContent: _('BC4 Kontaktní centrum'),
				}, {
					nodeName: 'p',
					textContent: _('BusinessCom a.s.'),
				}, {
					nodeName: 'p',
					children: [{
						nodeName: 'a',
						href: 'https://www.businesscom.cz',
						target: '_blank',
						textContent: _('www.businesscom.cz'),
					}]
				}, {
					nodeName: 'p',
					textContent: _('Dobrušská 1794/1\n147 00 Praha 4'),
				}, {
					nodeName: 'p',
					children: [{
						nodeName: 'a',
						href: 'tel:+420261303303',
						textContent: _('+420 261 303 303'),
					}, {
						nodeName: 'br',
					}, {
						nodeName: 'a',
						href: 'mailto:info@businesscom.cz',
						textContent: _('info@businesscom.cz'),
					}]
				}, {
					nodeName: 'p',
					textContent: _('Verze aplikace') + ': ' + ver.be,
				}]);
			},
		});
	},

	async showPasswordChangeDialog() {
		new Main.FormDialog({
			title: _('Změnit heslo'),

			renderFormFields() {
				let me = this;

				return [{
					xtype: 'PasswordTextField',
					name: 'password',
					label: _('Nové heslo'),
				}, {
					xtype: 'PasswordTextField',
					name: 'repeat_password',
					label: _('Potvrdit heslo'),
					'wrap:getViolation'(fn) {
						let err = fn();
						if (err) {
							return err;
						}

						let data = me.getFormFieldsData();
						if (data.password != this.getValue()) {
							return _('Hesla se neshodují');
						}

						return err;
					},
				}];
			},

			async onSave(data) {
				await REST.PUT('users/self', data);
			},
		});
	},

	updateServerStatus() {
		let ok = Application.socket.isReady();

		this.serverStatus.gwReplaceChildren(ok ? [Utils.useIcon('dot')] : [Utils.useIcon('dot'), {
			className: 'text',
			textContent: _('Server odpojen'),
		}]);

		this.serverStatus.dataset.status = ok ? 'ok' : 'fail';
	},
});

// }}}
// {{{ Main.ModulesScreen

GW.define('Main.ModulesScreen', 'Main.Screen', {
	'after:initComponent'() {
		let apps = Application.getAllowedModules();

		this.bodyEl.gwCreateChild({
			children: [{
				nodeName: 'h1',
				className: 'h2 main-title',
				textContent: _('Kontaktní centrum')
			}, {
				className: 'module-chooser',
				children: apps.map(m => this.renderModule(m)),
			}, {
				':skip': apps.length > 0,
				textContent: _('Nemáte přístup k žádným aplikacím'),
			}],
		});
	},

	renderModule(m) {
		return {
			className: 'module',
			nodeName: 'a',
			href: m.href,
			target: m.href_target,
			children: [{
				className: 'logo',
				children: [Utils.useIcon(m.icon || 'phone')],
			}, {
				className: 'info',
				children: [{
					className: 'title',
					textContent: m.title,
				}, {
					className: 'tagline',
					textContent: m.tagline,
				}],
			}],
		};
	},
});

// }}}
// {{{ Main.MessageScreen

GW.define('Main.MessageScreen', 'Main.Screen', {
	title: '',
	titleIcon: null,
	message: '',

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			nodeName: 'h2',
			textContent: this.message,
		}]);

		this.groupSelection.gwHide(true);
	},
});

// }}}
// {{{ Main.AccessDeniedScreen

GW.define('Main.AccessDeniedScreen', 'Main.Screen', {
	title: '',
	titleIcon: null,

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			nodeName: 'h2',
			textContent: _('K této aplikaci nemáte přístup'),
		}]);

		this.groupSelection.gwHide(true);
	},
});

// }}}
// {{{ Routes

Application.addRoutes([{
	group: 'public',
	path: APP_BASE,
	async handler({params}) {
		if (!Application.session || !Application.session.user) {
			await Application.replaceRoute(APP_BASE + 'login');
			return;
		}

		let c = Application.show({
			id: 'main.modules',
			xtype: 'Main.ModulesScreen',
		});

		//c.applyParams(params);
	}    
}]);

// }}}
